import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { DEFAULT_PRIVATE_ROUTE } from '../constants';

function PublicRoute({ currentUser, initialized, ...props }) {
  if (initialized && currentUser) {
    return <Redirect to={DEFAULT_PRIVATE_ROUTE} />;
  }
  return <Route {...props} />;
}

PublicRoute.defaultProps = {
  currentUser: false,
  initialized: false,
};

PublicRoute.propTypes = {
  ...Route.propTypes,
  currentUser: PropTypes.bool,
  initialized: PropTypes.bool,
};

function mapStateToProps({
  application: { initialized },
  auth: { currentUser },
}) {
  return {
    initialized,
    currentUser: Boolean(currentUser),
  };
}

export default connect(mapStateToProps)(PublicRoute);



// WEBPACK FOOTER //
// ./src/app/components/Routes/components/PublicRoute.js